import { grey } from "@mui/material/colors";

export const style = {
  background: {
    background: "#060e0e",
  },
  grantButton: {
    justifyContent: "flex-start",
    "&.Mui-disabled": {
      background: grey[600],
    },
  },
  dateFont: {
    fontWeight: 400,
  },
  whiteText: {
    color: (theme) => theme.palette.common.white,
    fontWeight: 400,
  },
  cardContainer: {
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 2,
    mt: 2,
  },
  cardImgBackground: (color) => {
    return {
      justifyContent: "center",
      alignItems: "center",
      width: "46px",
      height: "38px",
      background: color,
    };
  },
  graphContainer: {
    background: (theme) => theme.palette.common.white,
    borderRadius: "12px",
    p: 4,
  },
  grantDetailBackground: {
    width: "100%",
    minHeight: "350px",
    background: "#060e0e",
    zIndex: -9,
    position: "absolute",
  },
};
